import { render, staticRenderFns } from "./DarkMode.vue?vue&type=template&id=74b4e792&scoped=true"
import script from "./DarkMode.vue?vue&type=script&lang=js"
export * from "./DarkMode.vue?vue&type=script&lang=js"
import style0 from "./DarkMode.vue?vue&type=style&index=0&id=74b4e792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b4e792",
  null
  
)

export default component.exports